module.exports = __webpack_public_path__ + "static/img/outer.e139dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/outer.png
// module id = sh5I
// module chunks = 1